import React, { Component } from 'react';
import Datas from '../../data/walloffame/wallOfFame.json';
import DatasNew from '../../data/walloffame/wallOfFameNew.json';
import { Container, Row, Col } from 'react-bootstrap';
import ModalImage from "react-modal-image";
import HeaderTwo from '../../components/HeaderTwo';
import { BreadcrumbBox } from '../../components/common/Breadcrumb';
import FooterTwo from '../../components/FooterTwo';
import { Styles } from './styles/gallery.js';

class WalloffameComponent extends Component {
    render() {

        return (
            <Styles>
                {/* Main Wrapper */}
                <div className="main-wrapper gallery-page">

                    {/* Header 2 */}
                    <HeaderTwo />

                    {/* Breadcroumb */}
                    <BreadcrumbBox title="Success Stories" />

                    {/* Gallery Area */}
                    <section className="gallery-page-area">
                        <Container>
                            <Row>
                                {
                                    DatasNew.map((data, i) => (
                                        <Col lg="3" sm="6" key={i}>
                                            <div className="gallery-box">
                                                <ModalImage small={process.env.PUBLIC_URL + `/assets/images/LM/walloffame/New-Wall/${data.galleryImage}`} large={process.env.PUBLIC_URL + `/assets/images/LM/walloffame/New-Wall/${data.galleryImage}`} alt="" />
                                            </div>
                                        </Col>
                                    ))
                                }
                                {
                                    Datas.map((data, i) => (
                                        <Col lg="3" sm="6" key={i}>
                                            <div className="gallery-box">
                                                <ModalImage small={process.env.PUBLIC_URL + `/assets/images/LM/walloffame/${data.galleryImage}`} large={process.env.PUBLIC_URL + `/assets/images/LM/walloffame/${data.galleryImage}`} alt="" />
                                            </div>
                                        </Col>
                                    ))
                                }
                            </Row>
                        </Container>
                    </section>

                    {/* Footer 2 */}
                    <FooterTwo />

                </div>
            </Styles>
        )
    }
}

export default WalloffameComponent